import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Auth
import { db, store } from "./../firebase";
import { directStore } from "./../firebase/firestore";

function* handleDB(action) {
  const { data, filter, uUID } = action.meta;
  if (filter === "fetch_user" && data && uUID) {
    const userSnapshot = yield db.onceGetUser(uUID);

    //If none, bail
    if (userSnapshot.val() === null) return;

    const isClient = userSnapshot.val().role === "client";
    let clientData = null;

    //Fetch data
    yield put({
      type: ACTIONS.FETCH_DATA,
      payload: { ...userSnapshot.val() }
    });

    /*

      LOGS

    */
    //Get logs from cloud, give to redux
    let logs = [];
    if (isClient) {
      const logSnapshot = yield store.getLogs(uUID);
      if (logSnapshot) {
        logSnapshot.forEach(doc => logs.push(doc.data()));
      }
      yield put({ type: ACTIONS.FETCH_LOGS, payload: logs });
    }

    // Est. watcher
    directStore.collection(`clients/${uUID}/logs`).onSnapshot(doc => {
      let logs = [];
      doc.forEach((e, i) => {
        logs.push(e.data());
      });
      action.meta.dispatch({ type: ACTIONS.UPDATE_LOGS, payload: logs });
    });

    //If client, fetch users
    if (isClient) {
      const clientSnapshot = yield db.onceGetClient(uUID);
      clientData = clientSnapshot.val();
    }

    yield put({
      type: ACTIONS.UPDATE_USER,
      payload: {
        ...userSnapshot.val(),
        userDataFetched: true,
        ...clientData
      }
    });

    yield put({
      type: ACTIONS.FETCH_DATA,
      payload: userSnapshot.val()
    });

    const name = userSnapshot.val().profile.name;
    yield put({
      type: ACTIONS.OPEN_SNACKBAR,
      payload: {
        variant: "success",
        message: `${name.toLowerCase()} is logged in`
      }
    });

    yield put({
      type: ACTIONS.IS_AUTHENTICATED,
      payload: userSnapshot ? true : false
    });
  }
  /* 

  UPDATE CLIENT OBJECT FROM DATABASE

  */
  if (filter === "update") {
    const { cUID } = action.meta;
    const clientSnapshot = yield db.onceGetClient(cUID);

    yield put({
      type: ACTIONS.UPDATE_CLIENT,
      payload: clientSnapshot.val()
    });
  }
}

export function* dbWatcher() {
  yield takeEvery(ACTIONS.HIT_DB, handleDB);
}



// WEBPACK FOOTER //
// ./src/sagas/db.js